export default (savedItems, currentItemId) => {
  const allItemIds = Object.keys(savedItems);
  const nonCurrentItemIds = allItemIds.filter((itemId) => parseInt(itemId, 10) !== currentItemId);
  return nonCurrentItemIds.length;
};
